import { render } from "./SourceForm.vue?vue&type=template&id=43075bf5"
import script from "./SourceForm.vue?vue&type=script&lang=js"
export * from "./SourceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__